import { SmartReportComponents } from '../components/Components';

export const useGetComponents = ({ type, reportType, layout }) => {
  const components = SmartReportComponents.filter((component) => {
    // filter components based on type and reportType and layout if provided
    if (layout && layout.elementTypes.includes(component.type)) {
      return component.type === type && component.reportTypes?.includes(reportType);
    }

    return component.type === type && component.reportTypes?.includes(reportType);
  });

  return {
    components,
  };
};
